import * as React from 'react';
import { Responsive } from '@cian/ui-kit/responsive';

import { DesktopView } from './views/DesktopView';
import { MobileView } from './views/MobileView';

export const App = () => {
  return (
    <React.Fragment>
      <Responsive desktop>
        <DesktopView />
      </Responsive>
      <Responsive tablet phone>
        <MobileView />
      </Responsive>
    </React.Fragment>
  );
};
